import { AttributesMixin, define, Model, type } from "@type-r/models";
import { matchString } from "api/common";
import { asTimelessDate } from "lqx-react/lib";
import { AssetChange } from "./assetChange";
import { AssetType } from "./assetType";
import { CommonParticipant } from "./commonParticipant";
import { CreditNote } from "./creditNote";
import { restfulIO } from "./endpoint";

export interface CreditNoteChange extends AttributesMixin<typeof CreditNoteChange> { }
@define
export class CreditNoteChange extends AssetChange {
    static endpoint = restfulIO('api/v1/ingest/creditNotes/assets');
    static attributes = {
        ...AssetChange.attributes,
        updateAsset: CreditNote,
        assetType: type(Number).value(AssetType.creditNote),
    };

    getAssetType() {
        return AssetType.creditNote;
    }

    getAssetName() {
        return 'Credit Note';
    }

    get supplier(): CommonParticipant {
        return this.getValue("supplier") || new CommonParticipant();
    }

    get buyer(): CommonParticipant {
        return this.getValue("buyer") || new CommonParticipant();
    }

    get issuanceDate(): Date {
        const value = this.getValue("issuanceDate");
        return value ? new Date(value) : null;
    }

    get amount(): Number {
        return this.getValue("amount");
    }

    get currency(): string {
        return this.getValue("currency");
    }
    get number(): string {
        return this.getValue("number");
    }

    filter(filter) {
        return (matchString(this.supplier.name, filter.search) ||
            matchString(this.buyer.name, filter.search) ||
            matchString((this.amount || '').toString(), filter.search) ||
            matchString(asTimelessDate(this.issuanceDate), filter.search) ||
            matchString(this.currency, filter.search) ||
            matchString(this.number, filter.search) ||
            matchString(this.state.name, filter.search)) &&
            this.hasReceivedAssetEventsFor(filter.eventType);
    }
}

export interface CreditNoteData extends AttributesMixin<typeof CreditNoteData> { }
@define
export class CreditNoteData extends Model {
    static endpoint = restfulIO('api/v1/ingest/creditNotes/assets');

    static attributes = {
        count: Number,
        items: [CreditNoteChange]
    };
}
